import { TableCell, TableHead, TableRow, Typography } from "@mui/material";

const Header = ({ status }: { status: string }) => {
    return (
        <TableHead>
            <TableRow>
                <TableCell>
                    <Typography variant="body2">Template</Typography>
                </TableCell>
                <TableCell align="right">
                    <Typography variant="body2">Content</Typography>
                </TableCell>
                <TableCell align="right">
                    <Typography variant="body2">Transition</Typography>
                </TableCell>
                <TableCell align="right">
                    <Typography variant="body2">Orientation</Typography>
                </TableCell>
                <TableCell align="right">
                    <Typography variant="body2">Business Name</Typography>
                </TableCell>
                {status === "active" && <TableCell align="right">
                    <Typography variant="body2">Last Updated</Typography>
                </TableCell>}
                {status === "active" && <TableCell align="right" width={200}>
                    <Typography variant="body2">Actions</Typography>
                </TableCell>}
                {status === "archived" && <TableCell align="right">
                    <Typography variant="body2">Archived At</Typography>
                </TableCell>}
            </TableRow>
        </TableHead>
    )
}

export default Header;
